export const OTA_COMMISSION_MULTIPLIER = 0.2
export const OTA_COMISSION_PERCENT = OTA_COMMISSION_MULTIPLIER * 100

export function repeatGuestSorter(item1, item2) {
  const a = Number(item1.name.match(/\d+/)[0])
  const b = Number(item2.name.match(/\d+/)[0])

  return a - b
}

export function sliceLastTwelveMonthsExceptOne(arr) {
  return arr.slice(Math.max(arr.length - 12, 0), arr.length - 1)
}
